export default __webpack_public_path__ + "static/FIRE RETARDANT GRADE LAMINATES-6f90c7e72646786818af83dcf872a9a3.webp";